import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LiquidityPeriodBalanceType,
  PolicyOrAccount,
} from "../../interfaces/DTO/mislaka_xml_models";
import { formatLiquidityPeriodBalanceType } from "../../utils/enumFormatter";
import { formatCurrency } from "../../utils/namesFormater";
import { MimshakService } from "../../services/mimshakService";

interface SavingsSummaryProps {
  policy?: PolicyOrAccount;
  policies?: PolicyOrAccount[];
  balanceTypes?: LiquidityPeriodBalanceType[];
}

const ALL_TYPES = [
  LiquidityPeriodBalanceType.CAPITAL,
  LiquidityPeriodBalanceType.PAYING_PENSION,
  LiquidityPeriodBalanceType.NON_PAYING_PENSION,
  LiquidityPeriodBalanceType.CUSTOMER_CHOICE,
];

const SavingsSummary: React.FC<SavingsSummaryProps> = ({ policy, policies, balanceTypes }) => {
  const resolved: PolicyOrAccount[] = policies ?? (policy ? [policy] : []);

  const typesToShow = balanceTypes ?? ALL_TYPES;

  const parts = typesToShow
    .map((type) => {
      const total = MimshakService.calculateTotalsByType(resolved, type);
      return total > 0 ? `${formatLiquidityPeriodBalanceType(type)}: ${formatCurrency(total)}` : null;
    })
    .filter(Boolean) as string[];

  return (
    <Box sx={{ textAlign: "right", padding: "10px", border: "1px solid #ddd" }}>
      <Typography variant="h6">
        {parts.length > 0 ? parts.join(" | ") : "אין נתונים להצגה"}
      </Typography>
    </Box>
  );
};

export default SavingsSummary;
